import { render, staticRenderFns } from "./ProductoEmpresaHistorial.vue?vue&type=template&id=566493e2&scoped=true&"
import script from "./ProductoEmpresaHistorial.vue?vue&type=script&lang=js&"
export * from "./ProductoEmpresaHistorial.vue?vue&type=script&lang=js&"
import style0 from "./ProductoEmpresaHistorial.vue?vue&type=style&index=0&id=566493e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566493e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VBtn,VBtnToggle,VCard,VChip,VIcon,VProgressLinear,VTimeline,VTimelineItem})
